<template>
  <el-popover width="260" trigger="click">
    <div class="">
      <div class="flex-between padding-bottom-3">
        <div class="flex-start">
          <Checkbox
            class="margin-right-15"
            :key="columnsShow.id"
            :indeterminate="indeterminate"
            v-model="showColumns"
            :label="columnsShow.label"
            disabled
          />

          <!-- <Checkbox
            class="margin-right-10"
            @change="onChange"
            v-model="checked"
            :key="columnsIndex.id"
            :label="columnsIndex.label"
          /> -->

          <!-- <Checkbox
            :key="columnsSelect.id"
            v-model="columnsSelect.show"
            :label="columnsSelect.label"
          /> -->
        </div>
        <el-button @click="resetColumns" type="text">重置</el-button>
      </div>
      <div class="color-bg-f6 column-list border-radius-5 padding-x-10 padding-y-5">
        <TableColumnDragItem :list="checkedList" @onChange="onColumnChange" />
      </div>
    </div>
    <div slot="reference" class="padding-5 pointer flex-center">
      <img :src="item.icon" :style="{ width: item.size + 'px', height: item.size + 'px' }" />
    </div>
  </el-popover>
</template>
<script >
import { inject, computed } from '@vue/composition-api';
import Checkbox from './check-box.vue';
import { useSettings } from '../../../hooks';
import TableColumnDragItem from './table-column-drag-item.vue';
const __sfc_main = {};
__sfc_main.props = {
  item: {
    type: Object,
    default: () => {}
  },
  localColumns: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const checkedList = computed(() => props.localColumns.filter(item => !item.forceHide));
  const {
    resetColumns,
    setColumns
  } = inject('columnsInfo');
  const tableRef = inject('tableRef');
  const showColumns = computed(() => checkedList.value.every(item => item.checked));
  const indeterminate = computed(() => !showColumns.value && checkedList.value.some(item => item.checked));
  const {
    columnsShow
  } = useSettings();
  let time = null;
  const onColumnChange = list => {
    setColumns(list);
    if (time) {
      clearTimeout(time);
    }
    time = setTimeout(() => {
      if (tableRef.value && tableRef.value.doLayout) {
        tableRef.value.doLayout();
      }
      clearTimeout(time);
    }, 1200);
  };
  return {
    checkedList,
    resetColumns,
    showColumns,
    indeterminate,
    columnsShow,
    onColumnChange
  };
};
__sfc_main.components = Object.assign({
  Checkbox,
  TableColumnDragItem
}, __sfc_main.components);
export default __sfc_main;
</script>
<style scoped lang="scss">
  .column-list {
    max-height: 300px;
    overflow: auto;
  }
</style>
